/* 🤖 this file was generated by svg-to-ts */
export const matIconSort: {
  name: 'sort';
  data: string;
} = {
  name: 'sort',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"/></svg>`
};
